module.exports = __webpack_public_path__ + "img/aerospace_card.db3a573c.jpg";